import { Component, Input, OnInit, Renderer2 } from "@angular/core";
import { LayoutStoreService } from "@shared/layout/layout-store.service";

@Component({
  selector: "app-mainsidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"],
})
export class MainSidebarComponent implements OnInit {
  sidebarExpanded: boolean;
  sidebarAberta: boolean;
  @Input() route: String;
  rota: String;

  constructor(
    private renderer: Renderer2,
    private _layoutStore: LayoutStoreService
  ) {}

  ngOnInit(): void {
    this._layoutStore.sidebarExpanded.subscribe((value) => {
      this.sidebarExpanded = value;
      this.toggleSidebar();
    });

    const segments = this.route.split("/");

    this.rota = segments[1];
  }

  toggleSidebar(): void {
    if (this.sidebarExpanded) {
      this.hideSidebar();
    } else {
      this.showSidebar();
    }
  }

  showSidebar(): void {
    this.renderer.removeClass(document.body, "sidebar-collapse");
    this.sidebarAberta = true;
  }

  hideSidebar(): void {
    this.renderer.removeClass(document.body, "sidebar-open");
    this.renderer.addClass(document.body, "sidebar-collapse");
    this.sidebarExpanded = false;
    this.sidebarAberta = false;
  }
}
